import { Injectable, Optional, SkipSelf } from '@angular/core';
import { Subject } from 'rxjs';

export interface ToastMessage {
    message: string;
    cssClass: string;
}

@Injectable({
  providedIn: 'root'
})
export class ToastService {
    private toastSubject = new Subject<ToastMessage>();

    toastState = this.toastSubject.asObservable();

    constructor(@Optional() @SkipSelf() prior: ToastService) {
        if (prior) {
            return prior;
        }
    }

    activate(message?: string, cssClass?: string) {
        this.toastSubject.next(<ToastMessage>{ message: message, cssClass: cssClass });
    }
}
